export const SAVE_CULTURE_AND_TRANSLATIONS = 'SAVE_CULTURE_AND_TRANSLATIONS';